/* eslint no-undef: 0 */

export default {
  props: ['id'],
  $_veeValidate: {
    validator: 'new'
  },
  data: () => ({
    item: {},
    carregando: false,
    deu_erro: false,
    salvando: false,
    excluindo: false,
    dialog_excluir: false,
    requestShow: null,
    requestStore: null,
    requestUpdate: null,
    requestDestroy: null,
    requestRestore: null,
    presenter: null,
  }),
  created() {
    if (this.presenter) {
      this.carregando = !this.eh_novo;
      import(`@Presenter/${this.presenter}-presenter`)
        .then(Presenter => {
          this.presenter = Presenter.default;
          this.requestShow = Presenter.default.show;
          this.requestStore = Presenter.default.store;
          this.requestUpdate = Presenter.default.update;
          this.requestDestroy = Presenter.default.destroy;
          this.requestRestore = Presenter.default.restore;
          this.show();
        });
    }
  },
  methods: {
    show() {
      if (!this.eh_novo && this.id)
        this.requestShow(this.id)
          .then(response => {
            this.item = response;

            this.afterFetch();
          })
          .catch(() => {
            this.deu_erro = false;
          })
          .finally(() => {
            this.carregando = false;
          });
    },
    afterFetch() { },
    afterStore(response) { },
    customValidation() {
      return new Promise(resolve => {
        resolve({ bool: true, message: 'Sem erro' });
      });
    },
    async submeter() {
      let is_valid = await this.$validator.validateAll();
      if (!is_valid) {
        this.$store.dispatch('SHOW_SNACKBAR', {
          color: 'error',
          message: this.errors.all()[0]
        });
        return;
      }
      is_valid = await this.customValidation();
      if (!is_valid.bool) {
        this.$store.dispatch('SHOW_SNACKBAR', {
          color: 'error',
          message: is_valid.message || 'Erro!'
        });
        return;
      }
      const data = await this.createData();
      this.salvar(data);
    },
    salvar(data) {
      this.salvando = true;
      const $http = this.eh_novo ? this.requestStore : this.requestUpdate;
      $http(data)
        .then(response => {
          this.afterStore(response);
          this.salvo(response);
          this.fechaModal();
        })
        .finally(() => {
          this.salvando = false;
        });
    },
    salvo(item) {
      this.$emit('salvo', item);
    },
    excluir() {
      this.excluindo = true;
      const request = this.item.deleted_at ? this.requestRestore : this.requestDestroy;
      request(this.item.id)
        .then(() => {
          this.dialog_excluir = false;
          this.excluido(this.item);
          this.fechaModal();
        })
        .finally(() => {
          this.excluindo = false;
        });
    },
    excluido(item) {
      this.$emit('excluido', item);
    },
    fechaModal() {
      this.$emit('update:close', false);
    }
  },
  computed: {
    eh_novo() {
      return typeof this.id !== 'number';
    },
    btn_delete_title() {
      if (this.eh_novo) return null;
      return this.item.deleted_at ? 'Restaurar' : 'Inativar';
    },
    deletado() {
      return !!this.item.deleted_at;
    }
  }
};
